"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaaConfigsContext = exports.TaaConfigsContextProvider = exports.TaaConfigsContext = void 0;
const react_1 = __importStar(require("react"));
const useCurrentStage_1 = require("../../client/useCurrentStage");
const fetchUtils_1 = require("../../client/fetchUtils");
const DateManagement_1 = require("../../utils/DateManagement");
exports.TaaConfigsContext = (0, react_1.createContext)({
    clientName: 'TAAComponents',
    host: undefined,
    currentStage: fetchUtils_1.Stage.BETA,
    associateInfo: {
        employeeId: undefined,
        timeZone: undefined,
        siteId: undefined,
        locale: undefined,
        countryCode: undefined,
        linesOfBusiness: undefined
    },
    BIAnalytics: undefined
});
const TaaConfigsContextProvider = ({ taaConfigs, children }) => {
    const currentStage = (0, useCurrentStage_1.useCurrentStage)();
    const { associateInfo } = taaConfigs;
    (0, DateManagement_1.setTimeZoneAndLocale)(associateInfo === null || associateInfo === void 0 ? void 0 : associateInfo.timeZone, associateInfo === null || associateInfo === void 0 ? void 0 : associateInfo.locale);
    return (react_1.default.createElement(exports.TaaConfigsContext.Provider, { value: Object.assign({ associateInfo,
            currentStage }, taaConfigs) }, children));
};
exports.TaaConfigsContextProvider = TaaConfigsContextProvider;
const useTaaConfigsContext = () => (0, react_1.useContext)(exports.TaaConfigsContext);
exports.useTaaConfigsContext = useTaaConfigsContext;
